import { useState, useEffect, useContext } from 'react'
import style from '../../index.module.scss'
import { message, Modal, Input, Button, Tooltip } from 'antd'
import {
    putExcellingTopic, reuqestDelFavorite, getExcellingTopic
} from '../../../../api/networkDisk'
// import { deepCopy } from "../../../../util";
import { DeleteOutlined, EditFilled, CheckOutlined } from '@ant-design/icons';
// import { getMaxListeners } from 'process';
import { StorageModule } from "../../../../modules/storage";
import useStore from '../../../../store/useStore'
// import { useHistory } from 'react-router-dom'
import myContext from '../../../../utils/context'
import { createHashHistory } from "history";
import * as apis from '../../../../api/networkDisk'
import { memosModule } from '../../../../modules/memos'

interface Props {
    data: any
    index: number
    colIndex: number
    activeIndex?: number;
    onClickEdit: (data: any, index: number, colIndex: number) => void;
    onGetList: (colIndex?: number, param?: any, type?: string) => void;
    setInitNode?: (...args: any[]) => void;
    setMoveNode?: (...args: any[]) => void;
    setMovePlace?: (...args: any[]) => void;
    onDel?: (...args: any[]) => void;
    editItem?: (...args: any[]) => void;
    list: any;
    /**
     * 调用源页面的属性，单列则点击item后不出发接口请求
     * limitCols表示单列
     */
    attributeType?: any;
    html?: any;
    disable?: any;

}

interface State {
    saveLoading: boolean
    delVisible: boolean
    dataId: any
    shareVisible: boolean
    cancelVisible: boolean

}
const user: any = StorageModule.getUser().user;
const FileItemEdit = (props: Props) => {
    const [state, setState] = useState<State>({
        saveLoading: false,
        delVisible: false,
        dataId: {},
        shareVisible: false,
        cancelVisible: false
    });
    // const [data, setDate] = useState<any>();
    const [title, setTitle] = useState<string>('');
    const [shareUrl, setShareUrl] = useState<string>('');
    const { store, dispatch } = useStore();
    const [dbClickCount, setDbClickCount] = useState<number>(0);
    const [isSelect, setIsSelect] = useState<boolean>(false);

    const reviceProps = useContext(myContext)
    let history = createHashHistory();
    // const history = useHistory()
    // 页面跳转方法
    useEffect(() => {
        // setDate(deepCopy(props.data))
        // setTitle(props.data.subject)
        // console.log(props.list, props.data)
    }, [props.data])
    useEffect(() => {
        console.log(props.data.subject)
        setTitle(props.data.subject)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data.isCompile])
    useEffect(() => {
        if (props.activeIndex) {
            // console.log("用props.activeIndex")
            setIsSelect(props.activeIndex == props.index)
        } else {
            // console.log("用props.data.isSelect")
            setIsSelect(props.data.isSelect)
        }
    }, [props.activeIndex, props.data.isSelect])

    /**
    * @name 我的收藏-目录change
    */
    const onCollectionChange = (e: any, item: any): void => {
        console.log('onCollectionChange', e.target.value)
        setTitle(e.target.value)
    }
    /**
     * @name 我的收藏-编辑目录名称
     */
    const onCompileCollection = async (item?: any, type?: string): Promise<any> => {
        console.log(title, item)
        if (item.isCompile && title === '') {
            message.warning('请输入目录名称！')
            return
        }
        let judgeFn: any = new RegExp(/\s+/g);
        if (judgeFn.test(title)) {
            message.warning('名称不能有空格！')
            return
        }
        setState({ ...state })
        if (type === 'blur') {


            try {
                let res: any = await getExcellingTopic(props.data.id)
                if (res.ok) {
                    let params: any = {
                        $operate$: "save",
                        memoId: res.data.memoId,
                        subject: title
                    }

                    await putExcellingTopic(props.data.id, params)?.then(() => {
                        message.success('修改成功')
                        props.onGetList(props.colIndex, { parent: item.parentId }, 'edit')
                    })
                }
            } catch (err) { }
        }
        // setState({ ...state })
    }
    /**
    * @name 删除目录
    */
    const onDelete = async (id: any): Promise<any> => {
        state.delVisible = true
        state.dataId = id
        setState({ ...state })
    }
    /**
     * @name 删除目录-取消
     */
    const onDeleteClose = (): void => {
        state.delVisible = false
        setState({ ...state })
    }
    /**
     * @name 删除目录-确定
     */
    const onDeleteConfirm = async (): Promise<any> => {
        let res: any = await reuqestDelFavorite(state.dataId)
        state.delVisible = false
        props.onGetList(props.colIndex, { parent: props.data.parentId }, 'delete')
        if (res.ok) {
            //删除当前主题跳转默认主题
            if (state.dataId === store.subjectInfo.subjectId) {
                dispatch({
                    type: 'SET_SUBJECTINFO',
                    data: {
                        subjectCatalogue: [], subjectId: user.attachInfo.userTopicDesktop.rootTopicId
                        , data: {}
                    }
                });
            }
        }
    }
    const getList = () => {
        //刷新父组件列表
        props.onGetList && props.onGetList(props.colIndex + 1, { parent: props.data.id }, 'refreshe')

    }
    //删除当前监听
    const onDeleteListener = async (id: any) => {
        try {
            let res: any = await apis.deleteListener(id)
        } catch (e) { }
    }
    const getDetail = async (id: any, node?: any) => {
        try {
            await memosModule.getDetail(id).then((res) => {
                console.log('res', res)
                if (res.ok) {
                    let subjectInfo = {
                        subjectId: res.data.id,
                        subjectTitle: res.data.subject,
                        subjectCatalogue: res.data.catalogue,
                        total: res.data.memos.length,
                        data: res.data,
                        catalogueId: res.data.catalogueInfo,
                        permissions: res.data.permissions,
                    };

                    dispatch({
                        type: 'SET_SUBJECTINFO',
                        data: { subjectCatalogue: [], subjectId: props.data.id, data: subjectInfo }
                    });

                }
            }).catch((e) => {
                //console.log(e)
            })

        } catch (e: any) {
            //console.log(e.code)

        }
    }
    return (
        <>
            {
                <>
                    <div
                        className={`${style.list_column_item} unselect ${props.data.isCompile ? `${style.active}` : ''}${isSelect ? 'isSelect' : ''}`}
                        key={props.index + '_' + props.index}
                        data-flex="main:justify"
                        onDoubleClick={(e) => {

                            //新建主题时，不许双击
                            if (props.attributeType && props.attributeType == 'limitCols') {
                                return
                            }
                            if (reviceProps.isdbClick || props.data.isCompile) {
                                return
                            }
                            console.log('双击', props.data.id, store.subjectInfo.subjectId)
                            e.stopPropagation();
                            reviceProps.setModalClose(true)
                            if (props.data.id !== store.subjectInfo.subjectId) {
                                onDeleteListener(store.subjectInfo.subjectId)
                                getDetail(props.data.id)
                                window.location.hash = '#/view'
                            }

                            // StorageModule.set('subjectInfo', { ...store.subjectInfo, subjectId: props.data.id })
                        }}
                        onClick={(e) => {
                            setTimeout(() => {
                                // StorageModule.set('subjectId', props.data.id)
                                getList()
                            }, 200);
                            // 
                        }}
                        draggable={!props.data.isCompile}
                        onDragStart={() => props.setInitNode && props.setInitNode(props.data, props.colIndex)}
                        onDragOver={(e: any) => {
                            // props.setMoveNode && props.setMoveNode(e, props.data, props.colIndex, props.index)
                        }}
                        onDragEnd={(e: any) => {
                            props.setMovePlace && props.setMovePlace();
                        }}

                    >
                        <>{props.html && <div>{props.html}</div>}</>
                        <>{
                            props.data.isCompile ?
                                <span
                                    className={`${style.title} ${props.data.isSelect ? '' : ''} sl-ellipsis`}
                                    onClick={(e) => { e.stopPropagation() }}
                                    onBlur={(e) => {
                                        setTimeout(() => {
                                            props.onClickEdit(false, props.index, props.colIndex)
                                        }, 500)
                                    }}
                                >
                                    <Input
                                        onChange={(e) => onCollectionChange(e, props.data)}
                                        // onFocus={(e) => onCollectionFocus(e, props.data)}
                                        // onKeyDown={(e: any) => { e.keyCode === 13 && onCompileCollection(props.data, 'blur') }}

                                        type="text"
                                        autoFocus
                                        value={title}
                                        className={style.input}
                                        suffix={
                                            <CheckOutlined className='icon_hover' onClick={(e) => {
                                                e.stopPropagation();
                                                if (props.attributeType && props.attributeType == 'limitCols') {
                                                    props.editItem && props.editItem(title)
                                                    return
                                                } else {
                                                    onCompileCollection(props.data, 'blur')
                                                }
                                            }} />
                                        } />

                                </span> :
                                <>

                                    <span

                                        className={`${style.title} ${props.data.isSelect ? '' : ''} sl-ellipsis`}
                                    >
                                        <Tooltip placement="topLeft" title={props.data.subject}>
                                            <span>{props.data.subject}</span>
                                        </Tooltip></span>
                                    {isSelect && !props.disable && props.data?.ownerId === store.userInfo?.id ?
                                        <span className={style.btn} data-flex="main:justify cross:center">
                                            <EditFilled className='icon_hover mr-10'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    props.onClickEdit(true, props.index, props.colIndex)
                                                }
                                                }
                                            />
                                            <DeleteOutlined className='icon_hover' onClick={(e) => {
                                                e.stopPropagation();
                                                if (props.attributeType && props.attributeType == 'limitCols') {
                                                    props.onDel && props.onDel()
                                                    return
                                                } else {
                                                    onDelete(props.data.id)
                                                }
                                            }} />
                                        </span> : <></>}
                                </>
                        }
                        </>
                    </div>
                </>

            }
            <Modal
                centered
                className={style.selection_list}
                footer={[
                    <Button key="back" onClick={(e) => {
                        e.stopPropagation();
                        onDeleteClose()
                    }}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" danger onClick={(e) => {
                        e.stopPropagation();
                        onDeleteConfirm()
                    }}>
                        确认删除
                    </Button>,
                ]}
                closable={false}
                width={'40%'}
                title={'确认删除？'}
                open={state.delVisible}>
                <div>
                    删除此主题将会同时删除下级主题，确认删除？
                </div>
            </Modal>
        </>
    )
}

export default FileItemEdit